import { render, staticRenderFns } from "./effectMember.vue?vue&type=template&id=79670eba&scoped=true&"
import script from "./effectMember.vue?vue&type=script&lang=js&"
export * from "./effectMember.vue?vue&type=script&lang=js&"
import style0 from "./effectMember.vue?vue&type=style&index=0&id=79670eba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79670eba",
  null
  
)

export default component.exports